import { render, staticRenderFns } from "./IncubationTest.vue?vue&type=template&id=daf9a2a8&scoped=true&"
import script from "./IncubationTest.vue?vue&type=script&lang=js&"
export * from "./IncubationTest.vue?vue&type=script&lang=js&"
import style0 from "./IncubationTest.vue?vue&type=style&index=0&id=daf9a2a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf9a2a8",
  null
  
)

export default component.exports